import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9545a25a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "relative responsive-aspect-ratio configurator"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "relative w-full responsive-aspect-ratio" }
const _hoisted_4 = { class: "relative responsive-aspect-ratio" }
const _hoisted_5 = {
  key: 0,
  class: "relative video-aspect-ratio"
}
const _hoisted_6 = {
  key: 1,
  class: "relative responsive-aspect-ratio"
}

import { computed, ref } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { ModuleConfigurationImage, ProductDetailCoverMaterial } from '@/types/productServerApi';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import { ProductImageWithCacheBust } from '@/shared/product/details/useProductImages';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import { CollageTileLayoutData } from '@/shared/content/blocks/collage-layouts/collage-layout.store';
import ProductImageZoom from './ProductImageZoom.vue';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';
import constants from '@/shared/config/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'VisualizationOverlay',
  props: {
    productImages: null,
    isNewArrival: { type: Boolean },
    coverMaterial: null,
    environmentalImages: null,
    configuratorImages: null,
    damageImages: null,
    alt: null,
    isToggled: { type: Boolean },
    initialSlide: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
    productImages: ProductImageWithCacheBust[],
    isNewArrival?: boolean,
    coverMaterial?: ProductDetailCoverMaterial,
    environmentalImages?: CollageTileLayoutData[],
    configuratorImages?: ModuleConfigurationImage[],
    damageImages?: string[],
    alt?: string,
    isToggled?: boolean,
    initialSlide?: number,
}



const isToggled = computed(() => props.isToggled ?? false);


const { width, height } = useWindowSize();
const orientation = computed(() => width.value > height.value ? 'landscape' : 'portrait');
const aspectRatioForOverlay = computed(() => orientation.value === 'landscape' ? 16 / 9 : 1 / 1);
const isZooming = ref(false);

const isMobile = computed(() => breakpointsState.activeBreakpoint === 'xs');

const swiperOptions = computed(() => ({ zoom: { maxRatio: isMobile.value ? 5 : 3 } }));

const onZoomChange = ({ swiper }) => {
    const zoom = swiper.zoom?.currentScale === 1 ?? false;
    isZooming.value = zoom;
};

const touchEnd = ({ swiper }) => {
    if (swiper.zoom?.currentScale > 1) {
        isZooming.value = true;
    }
};


return (_ctx: any,_cache: any) => {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_ResponsiveImage = _resolveComponent("ResponsiveImage")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createBlock(BaseDialog, {
    "is-open": _unref(isToggled),
    class: "fixed inset-0 md:relative md:w-screen-85 md:h-screen-85 z-1 bg-wild-sand flex items-center swiper-pagination-zoom",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Swiper, {
        "initial-slide": __props.initialSlide,
        "free-mode": false,
        "hide-arrows": _unref(isMobile),
        options: _unref(swiperOptions),
        class: _normalizeClass(["bg-wild-sand h-full w-full z-0", {'mobile-action-zoom': _unref(isMobile)}]),
        onZoomChange: onZoomChange,
        onTouchEnd: touchEnd
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.productImages, (image, index) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: index,
              class: "swiper-slide"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["relative swiper-zoom-container", isZooming.value ? 'cursor-move' : 'cursor-zoom-in'])
                }, [
                  _createVNode(ProductImageZoom, {
                    sku: image.maybeAngleImageSku,
                    alt: __props.alt,
                    "aspect-ratio": _unref(aspectRatioForOverlay),
                    "is-zooming": isZooming.value,
                    "breakpoints-state": _unref(breakpointsState).activeBreakpoint,
                    "cache-bust": image.version
                  }, null, 8, ["sku", "alt", "aspect-ratio", "is-zooming", "breakpoints-state", "cache-bust"])
                ], 2)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.configuratorImages, (configurationImage, index) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: index,
              class: "swiper-slide"
            }, {
              default: _withCtx(() => [
                (__props.configuratorImages)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createElementVNode("img", {
                        src: configurationImage.content
                      }, null, 8, _hoisted_2)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          (__props.coverMaterial?.image)
            ? (_openBlock(), _createBlock(_component_SwiperSlide, {
                key: "coverMaterial",
                class: "swiper-slide"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_ResponsiveImage, {
                      class: "force-center",
                      "is-product-image": true,
                      mode: "contain",
                      "aspect-ratio": _unref(aspectRatioForOverlay),
                      "image-url": __props.coverMaterial?.image?.path,
                      "cache-bust": __props.coverMaterial?.image?.cacheBust,
                      alt: `${__props.coverMaterial.name} - ${__props.coverMaterial.materialType}, ${__props.coverMaterial.color.name}`
                    }, null, 8, ["aspect-ratio", "image-url", "cache-bust", "alt"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.damageImages, (damageImage) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: damageImage,
              class: "swiper-slide"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_ResponsiveImage, {
                    class: "force-center",
                    "image-url": damageImage,
                    "is-product-image": true,
                    mode: "contain",
                    alt: __props.alt,
                    "aspect-ratio": _unref(aspectRatioForOverlay),
                    "width-on-screen": 80
                  }, null, 8, ["image-url", "alt", "aspect-ratio"])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.environmentalImages, (environmentalImage) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: environmentalImage.model.media.model?.url ?? environmentalImage.model.media.model.image.url,
              class: "swiper-slide"
            }, {
              default: _withCtx(() => [
                (environmentalImage.model.media.type === _unref(constants).media.vimeoModel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(MediaHandler, {
                        "media-block": environmentalImage.model.media,
                        "media-aspect-ratio": 16/9,
                        "auto-fit-video-to-aspect-ratio": false
                      }, null, 8, ["media-block"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_ResponsiveImage, {
                        class: "force-center",
                        "image-url": environmentalImage.model.media.model.url,
                        "cache-bust": environmentalImage.model.media.model.cachebust,
                        mode: "contain",
                        alt: __props.alt,
                        "aspect-ratio": _unref(aspectRatioForOverlay),
                        "width-on-screen": 80
                      }, null, 8, ["image-url", "cache-bust", "alt", "aspect-ratio"])
                    ]))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["initial-slide", "hide-arrows", "options", "class"])
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})